export default {
  choose: {
    title: 'Remove {{name}} as owner',
    title_no_owner: 'Choose an owner for {{restaurant}}',
    description: 'Choose who takes over from {{name}}, or leave {{restaurant}} without an owner for now.',
    description_no_owner: '{{restaurant}} has no owner. Choose someone on the team, or someone new.',
    new_owner: 'New owner',
    previous_owner: '{{name}} after the change',
  },
  options: {
    team: {
      title: 'Someone on the team',
      loading: 'Loading the team…',
      description_one: 'Any Operator or Employee, {{count}} person.',
      description_other: 'Any Operator or Employee, {{count}} people.',
      empty: 'There’s no one else on the team yet.',
      search: 'Search the team by name or email',
      no_match: 'No one on the team matches “{{query}}”.',
    },
    new: {
      title: 'Someone new',
      description: 'They’re the owner straight away and get their login by email.',
    },
    none: {
      title: 'No owner for now',
      description: 'Choose an owner later. Until then, {{restaurant}} has no owner.',
    },
    keep: {
      title: 'Stays on the team as Operator',
      description: 'Keeps access to the restaurants they manage today.',
    },
    remove: {
      title: 'Removed from the team',
      description: 'Loses access to the dashboard right away.',
    },
  },
  roles: {
    operator: 'Operator',
    employee: 'Employee',
  },
  fields: {
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
  },
  email_errors: {
    invalid_email: 'Enter a valid email, like name@example.com.',
    email_is_owner: '{{name}} is already the owner.',
    email_is_manager: '{{name}} is already on the team.',
    email_taken: 'Someone outside this team already signs in with this email. Use a different email.',
  },
  confirm: {
    title: 'Remove {{name}} as owner?',
    title_no_owner: 'Make {{name}} the owner?',
    description_both: 'Both changes happen together. If one fails, nothing changes.',
    description: 'Check the change before you confirm.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> has no owner until you choose one. Anything that needs the owner waits until then.',
    new: '<b>{{name}}</b> becomes the owner of {{restaurant}} right away.',
    email: 'Their login goes to <b>{{email}}</b>. Check it: whoever has this email can sign in as the owner.',
    team: '<b>{{name}}</b> becomes the owner of {{restaurant}}.',
    group_access: 'As owner they get access to every restaurant of {{group}}, which can be more than they have today.',
    keep: '<b>{{name}}</b> stays on the team as Operator.',
    remove: '<b>{{name}}</b> is removed from the team and can’t sign in any more.',
  },
  error: {
    title: 'Couldn’t change the owner.',
    description: 'Nothing was changed. Try again, or contact support if it keeps failing.',
  },
  buttons: {
    continue: 'Continue',
    cancel: 'Cancel',
    back: 'Back',
    remove_as_owner: 'Remove as owner',
    make_owner: 'Make owner',
    saving: 'Saving…',
    try_again: 'Try again',
    choose_instead: 'Choose {{name}} instead',
    invite_instead: 'Invite someone new instead',
  },
};
